import React from 'react';
import ReactDOM from 'react-dom';
import {addLocaleData} from 'react-intl';
import en from 'react-intl/locale-data/en';
import ru from 'react-intl/locale-data/ru';
import './index.css';
import createBrowserHistory from 'history/createBrowserHistory';
import Root from './containers/Root';
import configureStore from './store/store';
import {loginUser, loginUserSuccess} from './actions';

const appConfig = window.APP_CONFIG;
const localeConfig = window.LOCALE_CONFIG;
addLocaleData([...en, ...ru]);

let locale = localeConfig.en;
const localeInfo = localStorage.getItem('localeInfo');
if (!!localeInfo && localeInfo !== ''){
   switch (localeInfo){
      case 'ru':
         locale = localeConfig.ru;
         break;
      case 'en':
         locale = localeConfig.en;
         break;
      default:
         locale = localeConfig.en;
         break;
   }
}

let initialState = {
   conf: appConfig,
   intl: locale,
   auth: {},
   data: {},
   ctrl: {},
   routing: {}
};

const sessionInitialState = sessionStorage.getItem('sessionInitialState');
if (!!sessionInitialState && sessionInitialState !== '') {
   const sessionInitialStateObj = JSON.parse(sessionInitialState);
   initialState = Object.assign({}, sessionInitialStateObj);
}

const history = createBrowserHistory();
const store = configureStore(history, initialState);

let sessionUserInfo = sessionStorage.getItem('sessionUserInfo');
if (!!sessionUserInfo && sessionUserInfo !== '') {
   const sessionUserInfoObj = JSON.parse(sessionUserInfo);
   store.dispatch(loginUserSuccess(sessionUserInfoObj));
} else {
   // Дефолтная авторизация
   let login = appConfig.defUser.login;
   let pass = appConfig.defUser.pass;
   const userCredentials = localStorage.getItem('userInfo');
   if (!!userCredentials && userCredentials !== '') {
      const userCredentialsObj = JSON.parse(userCredentials);
      login = userCredentialsObj.email;
      pass = userCredentialsObj.password;
   }
   store.dispatch(loginUser(login, pass, window.location.pathname));
}

ReactDOM.render(
   <Root store={store} history={history}/>,
   document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js